export default {"src":"/_next/static/media/ShapeShift_DAO.f3517e07.svg","height":208,"width":230,"blurWidth":0,"blurHeight":0};